import React from 'react'
import { createUseStyles } from 'react-jss'
import { LG } from '../constants/mediaQueries'

const useStyles = createUseStyles({
  root: {
    '& h2': {
      fontSize: 14,
      textAlign: 'center',
      fontFamily: 'Ubuntu',
      fontWeight: 400,
      color: '#fff',
      fontStyle: 'normal',
      letterSpacing: 0.7,
      lineHeight: 1.2,
      [LG]: {
        fontSize: 20
      }
    },
    '& p, & a': {
      textTransform: 'uppercase',
      fontSize: 14,
      textAlign: 'center',
      fontFamily: 'Ubuntu',
      fontWeight: 400,
      textDecoration: 'underline',
      textDecorationStyle: 'solid',
      color: '#fff',
      fontStyle: 'normal',
      letterSpacing: 0.7,
      lineHeight: 1.2,
      [LG]: {
        fontSize: 20
      }
    }
  }
})

const Credits = () => {
  const classes = useStyles()
  return (
    <div className={classes.root}>
      <h2>Website:</h2>
      <p>
        <a href="https://www.instagram.com/we_are_astral/" target="_blank">
          Astral
        </a>
      </p>
      <br />
      <h2>Sound:</h2>
      <p>
        <a href="https://www.instagram.com/juergenbranz/" target="_blank">
          JÜRGEN BRANZ
        </a>
      </p>
    </div>
  )
}

export default Credits
